module.exports = __webpack_public_path__ + "static/dslnw-logo-small4.6b09d400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commercial_logos/dslnw-logo-small4.jpg
// module id = 2171
// module chunks = 61762850755587